import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { Picker } from '@react-native-picker/picker';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import React__default from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { g as genericStyles } from './genericStyles-b9567994.esm.js';
import { a as AppIcon } from './index-6b88191c.esm.js';
import { useTranslation } from 'react-i18next';

const AppDropDown = _ref => {
  var _currentTheme$theme;
  let {
    items,
    dropDownStyle,
    propertyLabel = "label",
    propertyValue = "value",
    enabled = true,
    isElevated = true,
    dropdownIconColor,
    showTextInputLabel,
    isMandatory,
    label,
    wrapperContainer,
    leftIcon,
    leftIconStyle,
    leftIconColor,
    inputLabelStyle,
    inputLabelFontWeight,
    translateLabels,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const _style = styleGenerator(currentTheme, enabled, leftIcon);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_style.wrapperContainer, wrapperContainer]
  }, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    fontWeight: inputLabelFontWeight,
    style: [{
      marginBottom: 10,
      marginLeft: 10
    }, inputLabelStyle],
    isMandatory: isMandatory,
    label: label
  }) : null, leftIcon && /*#__PURE__*/React__default.createElement(AppIcon, {
    color: leftIconColor,
    icon: leftIcon,
    size: 25,
    style: [{
      marginLeft: 10,
      position: "absolute",
      marginTop: 5
    }, leftIconStyle]
  }), /*#__PURE__*/React__default.createElement(Picker, _extends({
    style: [_style.baseStyle, isElevated && genericStyles.genericShadowStyle, dropDownStyle],
    enabled: enabled,
    dropdownIconColor: dropdownIconColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color)
  }, props), items === null || items === void 0 ? void 0 : items.map(i => {
    if (i) return /*#__PURE__*/React__default.createElement(Picker.Item, {
      key: i[propertyValue] || i.toString(),
      label: translateLabels ? t(i[propertyLabel]) || t(i.toString()) : i[propertyLabel] || i.toString(),
      value: i[propertyValue] || i.toString()
    });
  })));
};
const styleGenerator = (props, enabled, leftIcon) => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5;
  return StyleSheet.create({
    baseStyle: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.small_font_size,
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.inputBackgroundColor,
      paddingVertical: 5,
      borderRadius: 10,
      borderColor: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.border_color,
      borderWidth: 1,
      height: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.fieldHeight,
      paddingHorizontal: 10,
      color: props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.darkGrey,
      cursor: Platform.OS === "web" && "pointer",
      paddingLeft: leftIcon && 45,
      paddingRight: 20
    },
    wrapperContainer: {
      flexDirection: "column",
      backgroundColor: "transparent"
    }
  });
};
AppDropDown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppDropDown",
  "props": {
    "propertyLabel": {
      "defaultValue": {
        "value": "\"label\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the property used for displaying the values"
    },
    "propertyValue": {
      "defaultValue": {
        "value": "\"value\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the property used for the value of the selection"
    },
    "enabled": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the dropdown can be opened"
    },
    "isElevated": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the dropdown has elevation and box shadowing applied"
    },
    "items": {
      "required": true,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": "Sets the items to display in the dropdown"
    },
    "dropDownStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Sets the style of the drop down"
    },
    "dropdownIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the color of the dropdown indicator"
    },
    "showTextInputLabel": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true displays a label at the top of the component"
    },
    "isMandatory": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true it appends an asterix to indicate that it a mandatory field"
    },
    "label": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Text displayed when showTextInputLabel is marked as true"
    },
    "wrapperContainer": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the overall wrapper of the component"
    },
    "leftIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "inputLabelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "leftIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": ""
    },
    "leftIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "inputLabelFontWeight": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "translateLabels": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    }
  }
};

export { AppDropDown as A };
